import { forwardRef } from "react";

import type { ViewProps as ViewPropsRN, View as ViewRN } from "react-native";
import type { ViewProps } from "tamagui";
import { View } from "tamagui";

import { getCursor } from "@/utils/cursor.util";

type NormalizedBoxProps = Omit<ViewProps, "accessibilityLabel"> &
  Pick<ViewPropsRN, "onLayout">;

interface BoxProps extends BaseContainerViewProps, NormalizedBoxProps {}

// eslint-disable-next-line react/display-name
const Box = forwardRef<ViewRN, BoxProps>(
  // eslint-disable-next-line max-params
  ({ accessibilityLabel, onLayout, testID, ...rest }, forwardedRef) => {
    return (
      <View
        // ACCESSIBILITY (JN-2526): Tamagui converts aria-label/role to accessibilityLabel/accessibilityRole
        // but doesn't set accessible={true}, which React Native requires for VoiceOver to detect elements.
        // Without this, screen readers cannot find interactive elements, making the app not accessible.
        accessible={Boolean(accessibilityLabel)}
        aria-label={accessibilityLabel}
        onLayout={onLayout}
        ref={forwardedRef}
        testID={testID}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
        cursor={getCursor(rest)}
      />
    );
  },
);

export type { BoxProps };
export default Box;
